// extracted by mini-css-extract-plugin
export default {"tip_comment":"tour_tip_comment__zZ9QI"};